module.exports = __webpack_public_path__ + "static/media/1.-Apply-illustration.d504c4ff.svg";